export interface Transaction {
  id: string;
  type: "payin" | "payout";
  status: "success" | "pending" | "failed" | "processing";
  customer: string;
  method: string;
  amount: number;
  fee: number;
  net: number;
  date: string;
  time: string;
}

export interface WalletBalance {
  available: number;
  pending: number;
  total: number;
}

export interface Settlement {
  id: string;
  amount: number;
  status: "completed" | "pending" | "scheduled";
  date: string;
  utr: string;
}

export interface ApiKey {
  id: string;
  name: string;
  key: string;
  mode: "live" | "test";
  created: string;
  lastUsed: string;
}

export interface Webhook {
  id: string;
  url: string;
  events: string[];
  status: "active" | "inactive";
  lastDelivery: string;
}

export const mockTransactions: Transaction[] = [
  {
    id: "TXN20250118001",
    type: "payin",
    status: "success",
    customer: "John Doe",
    method: "UPI",
    amount: 5000,
    fee: 100,
    net: 4900,
    date: "2025-01-18",
    time: "14:30",
  },
  {
    id: "TXN20250118002",
    type: "payout",
    status: "processing",
    customer: "Jane Smith",
    method: "Bank Transfer",
    amount: 12000,
    fee: 50,
    net: 11950,
    date: "2025-01-18",
    time: "13:45",
  },
  {
    id: "TXN20250118003",
    type: "payin",
    status: "success",
    customer: "Robert Johnson",
    method: "Card",
    amount: 8500,
    fee: 170,
    net: 8330,
    date: "2025-01-18",
    time: "12:15",
  },
  {
    id: "TXN20250117001",
    type: "payin",
    status: "failed",
    customer: "Emily Davis",
    method: "Net Banking",
    amount: 3200,
    fee: 0,
    net: 0,
    date: "2025-01-17",
    time: "18:20",
  },
  {
    id: "TXN20250117002",
    type: "payout",
    status: "success",
    customer: "Michael Brown",
    method: "UPI",
    amount: 6000,
    fee: 30,
    net: 5970,
    date: "2025-01-17",
    time: "16:00",
  },
  {
    id: "TXN20250117003",
    type: "payin",
    status: "success",
    customer: "Sarah Wilson",
    method: "Wallet",
    amount: 4500,
    fee: 90,
    net: 4410,
    date: "2025-01-17",
    time: "11:30",
  },
  {
    id: "TXN20250116001",
    type: "payin",
    status: "success",
    customer: "David Martinez",
    method: "UPI",
    amount: 7800,
    fee: 156,
    net: 7644,
    date: "2025-01-16",
    time: "15:45",
  },
  {
    id: "TXN20250116002",
    type: "payout",
    status: "success",
    customer: "Lisa Anderson",
    method: "Bank Transfer",
    amount: 15000,
    fee: 75,
    net: 14925,
    date: "2025-01-16",
    time: "10:00",
  },
  {
    id: "TXN20250116003",
    type: "payin",
    status: "pending",
    customer: "Alex Kumar",
    method: "UPI",
    amount: 3500,
    fee: 70,
    net: 3430,
    date: "2025-01-16",
    time: "09:30",
  },
  {
    id: "TXN20250115001",
    type: "payin",
    status: "success",
    customer: "Priya Sharma",
    method: "Card",
    amount: 12500,
    fee: 250,
    net: 12250,
    date: "2025-01-15",
    time: "17:20",
  },
  {
    id: "TXN20250115002",
    type: "payout",
    status: "success",
    customer: "Rahul Verma",
    method: "Bank Transfer",
    amount: 8900,
    fee: 45,
    net: 8855,
    date: "2025-01-15",
    time: "14:10",
  },
  {
    id: "TXN20250115003",
    type: "payin",
    status: "success",
    customer: "Anjali Patel",
    method: "Net Banking",
    amount: 6200,
    fee: 124,
    net: 6076,
    date: "2025-01-15",
    time: "11:45",
  },
  {
    id: "TXN20250114001",
    type: "payin",
    status: "success",
    customer: "Vikram Singh",
    method: "UPI",
    amount: 9800,
    fee: 196,
    net: 9604,
    date: "2025-01-14",
    time: "16:30",
  },
  {
    id: "TXN20250114002",
    type: "payout",
    status: "success",
    customer: "Neha Gupta",
    method: "UPI",
    amount: 4500,
    fee: 25,
    net: 4475,
    date: "2025-01-14",
    time: "13:15",
  },
  {
    id: "TXN20250114003",
    type: "payin",
    status: "failed",
    customer: "Amit Shah",
    method: "Card",
    amount: 5600,
    fee: 0,
    net: 0,
    date: "2025-01-14",
    time: "10:00",
  },
  {
    id: "TXN20250113001",
    type: "payin",
    status: "success",
    customer: "Sanjay Reddy",
    method: "Wallet",
    amount: 7200,
    fee: 144,
    net: 7056,
    date: "2025-01-13",
    time: "15:40",
  },
];

export const mockWalletBalance: WalletBalance = {
  available: 245000,
  pending: 38000,
  total: 283000,
};

export const mockSettlements: Settlement[] = [
  {
    id: "STL20250118001",
    amount: 125000,
    status: "completed",
    date: "2025-01-18",
    utr: "UTR2025011800001",
  },
  {
    id: "STL20250117001",
    amount: 98000,
    status: "completed",
    date: "2025-01-17",
    utr: "UTR2025011700001",
  },
  {
    id: "STL20250116001",
    amount: 156000,
    status: "pending",
    date: "2025-01-19",
    utr: "-",
  },
];

export const mockApiKeys: ApiKey[] = [
  {
    id: "1",
    name: "Production Key",
    key: "pk_live_51HxYz2SD...",
    mode: "live",
    created: "2024-12-01",
    lastUsed: "2025-01-18 14:30",
  },
  {
    id: "2",
    name: "Test Key",
    key: "pk_test_51HxYz2SD...",
    mode: "test",
    created: "2024-12-01",
    lastUsed: "2025-01-15 10:00",
  },
];

export const mockWebhooks: Webhook[] = [
  {
    id: "1",
    url: "https://example.com/webhooks/payment",
    events: ["payment.success", "payment.failed"],
    status: "active",
    lastDelivery: "2025-01-18 14:30",
  },
  {
    id: "2",
    url: "https://example.com/webhooks/payout",
    events: ["payout.success", "payout.failed"],
    status: "active",
    lastDelivery: "2025-01-18 13:45",
  },
];

export const mockChartData = [
  { date: "Jan 12", payin: 45000, payout: 32000 },
  { date: "Jan 13", payin: 52000, payout: 28000 },
  { date: "Jan 14", payin: 48000, payout: 35000 },
  { date: "Jan 15", payin: 61000, payout: 42000 },
  { date: "Jan 16", payin: 55000, payout: 38000 },
  { date: "Jan 17", payin: 67000, payout: 45000 },
  { date: "Jan 18", payin: 72000, payout: 51000 },
];
